import { useEffect, useRef, useState } from 'react';
import loginApi from 'api/loginApi';
import Common from 'Common'

const initLoginInfo = {
    userName: '',
    password: ''
}
export const useLogin = () => {
    const [loginInfo, setLoginInfo] = useState(initLoginInfo);
    const [isLoading, setIsLoading] = useState(false);
    const isFirstLoad = useRef(true);

    useEffect(() => {

        if (isFirstLoad.current) {
            isFirstLoad.current = false;
            return;
        }


        (async function login() {
            // const position = await Common.getPosition();
            const position = { Latitude: "", Longitude: "" };
            const loginUser = {
                userLogin: loginInfo.userName,
                password: loginInfo.password + Common.PW_TAIL,
                ...position
            }

            try {
                setIsLoading(true);
                /**Call Api */
                const dtResponse = await loginApi.login(loginUser);

                let cUser = dtResponse?.data['cUser'] ?? "";
                let cUserName = dtResponse?.data['cUserName'] ?? "";
                let cToken = dtResponse?.data['cToken'] ?? "";
                let cClientName = dtResponse?.data['cClientName'] ?? "";
                let cDivision = dtResponse?.data['cDivision'] ?? "";
                let cPrice = dtResponse?.data['cPrice'] ?? "";
                if (cUserName && cToken) {
                    Common.localStorageSetToken(cUser, cUserName, cToken, cClientName, cDivision, cPrice);
                    window.location.replace(Common.URL_HOME);
                } else {
                    //TODO: Login ERROR
                    throw new Error('ユーザーが存在しません。');
                }
            } catch (err) {
                alert('ログインに失敗しました！');
                setIsLoading(false);
            }
        })();
    }, [loginInfo])

    return { setLoginInfo, isLoading };
}